/**
 * Test IDs for QA automation.
 */
export const testIds = {
  userFormFirstName: "user-form-first-name",
  userFormLastName: "user-form-last-name",
  userFormEmail: "user-form-email",
  userFormRoles: "user-form-roles",
  userFormRoleOption: "user-form-role-option",
  userFormPasswordField: "user-form-password-field",
  userFormSave: "user-form-save",
} as const;
